module.exports = __webpack_public_path__ + "img/ИФ-1(А)-047-m.85459ffe.png";